import React from 'react';
import GameContext from '../gameContext';
import { TooltipButton } from '../tooltips';

/**
 * Generic input button. After the button is clicked once, it will be highlighted
 * to show that the input is in use. This is undone when the game is reset.
 */
const InputButton = (props) => {
  const gameContext = React.useContext(GameContext);
  const [inUse, setInUse] = React.useState(false);
  const [uses, setUses] = React.useState(0);

  const applyChange = () => {
    let newState = {
      ...gameContext,
      history: [...gameContext.history, props.data.name],
      prevStates: [...gameContext.prevStates, {inputData: props.data, state: gameContext}]
    }

    // do any additional overriding that might be specific to this input
    newState = {
      ...newState,
      ...props.data.apply(newState, true)
    };

    gameContext.changeState(newState);

    // update # of uses for this specific input
    setInUse(true);
    setUses(uses + 1);
  }

  const undoChange = () => {
    let revertIndex;
    let revertTo;

    for (let i = gameContext.history.length - 1; i >= 0; i--) {
      const historyItem = gameContext.history[i];
      // use includes bc the history item might have extra info,
      // i.e. "Clomiphene (Clomid)-HPA_CLOMID_HIGH"
      if (historyItem.includes(props.data.name)) {
        revertIndex = i;
        revertTo = gameContext.prevStates[i];
        break;
      }
    }

    // revert to the state before that input was applied
    // then apply all the inputs that came after
    let newState = revertTo.state;
    for (let i = revertIndex + 1; i < gameContext.prevStates.length; i++) {
      const input = gameContext.prevStates[i];
      newState = {
        ...newState,
        history: [...newState.history, gameContext.history[i]],
        prevStates: [...newState.prevStates, {...input, state: newState}]
      };
      newState = {
        ...newState,
        ...input.inputData.apply(newState, false),
      }
    }

    // any undo function that might be specific to the input
    if (props.data.undo !== undefined) {
      newState = props.data.undo(newState, gameContext.history[revertIndex]);
    } else {
      console.log("no undo function for this input");
    }

    gameContext.changeState(newState);

    // update # of uses for this input
    setUses(uses - 1);
    if (uses === 0) {
      setInUse(false);
    }
  }

  const getUsesColor = () => {
    if (inUse) {
      // TODO fix gameContext.history at some point
      if (uses > 0 && gameContext.history.length) {
        return "game-input-in-use";
      } else {
        // this needs to be in an inner block so we're not calling this
        // even if `inUse` is already false
        setInUse(false);
        setUses(0);
      }
    }
    return "";
  }

  const getTooltip = () => {
    if (props.tooltipText) {
      return <TooltipButton text={props.tooltipText}/>;
    }
  }

  return (
    <div className="game-input-slider-container">
      
      <div className="game-input-btn-row">
        <button className={`game-input-btn ${getUsesColor()}`} onClick={applyChange} disabled={inUse}>
          {props.data.name}
        </button>
        {getTooltip()}
      </div>

      {/* only show slider if in use */}
      {uses > 0 &&
      <div className="game-input-slider">
        <button className="game-input-btn" onClick={undoChange} disabled={uses === 0}>
          -
        </button>
        {uses}
        <button className="game-input-btn" onClick={applyChange} disabled={uses >= 10}>
          +
        </button>
      </div>
      }
    </div>
  )
}

export default InputButton;